import { api } from './_request';


export const alerta = (alerta) => {
	return (dispatch) => {
		dispatch({
					type: 'SAVE_ALERTA',
					payload: alerta
				});
	}
};

export const iniciallizar = () => {
	return (dispatch) => {
		dispatch({
					type: 'LIST',
				});
	}
};

export const elimnar_notificacion = (creacion) => {
	return (dispatch) => {
		dispatch({
					type: 'Eliminar_notificacion',
					payload: creacion
				});
	}
};


/*

Se tiene que agregar la sig funcion al action que se utilice en el componente donde se quiere crear la notificacion 

    export const alerta = (alerta) => {
		return (dispatch) => {
			dispatch({
						type: 'SAVE_ALERTA',
						payload: alerta
					});
		}
	};
Y agregar el reducer al componente

 notificciones:state.notificciones


llamada al action 
   this.props.alerta({
      mensaje:"Error al Capturar",
      tipo:"success",
      creacion:moment().format('Y-MM-DD H:m:s'),
      });


*/



// WEBPACK FOOTER //
// ./src/actions/notificaciones.js